<template>
  <div>
    <div v-if="current && current.req_traslado_e">
      <div
        style="z-index: 1000 !important"
        class="floated-colors-btn second-floated-btn"
        @click="cambiarUiTabla"
      >
        <div class="os-toggler-w" :class="{ on: cambiar_UiTabla }">
          <div class="os-toggler-i">
            <div class="os-toggler-pill"></div>
          </div>
        </div>
        <span v-if="!cambiar_UiTabla">Tabla Detalle</span>
        <span v-if="cambiar_UiTabla">Tabla Resumen</span>
      </div>
      <div class="row mt-2">
        <div class="col-lg-12">
          <div class="padded-lg">
            <!--START - Projects list-->
            <div v-if="!cambiar_UiTabla" class="projects-list">
              <div
                class="project-box"
                v-for="detalle in current.req_traslado_e.reqtrasladod_set"
                :key="detalle.id"
                @click="abrirModalEliminarDetalle(detalle)"
              >
                <div
                  class="project-head"
                  style="padding-rigth: 1em; padding-left: 1em"
                >
                  <div class="project-title">
                    <h5>
                      {{ detalle.producto.sku }}
                    </h5>
                    <small>{{ detalle.producto.nombre }}</small>
                  </div>
                  <div
                    class="badge badge-info form-inline justify-content-sm-end"
                    v-if="detalle.producto && detalle.producto.categoria"
                  >
                    {{ detalle.producto.categoria.nombre }}
                  </div>
                  <div class="project-info">
                    <div class="row align-items-center">
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-4">
                            <div class="el-tablo highlight">
                              <div class="label">Pickeado</div>
                              <h5 style="color: green">
                                {{
                                  detalle.cantidad - detalle.cantidad_abierta
                                }}
                              </h5>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="el-tablo highlight">
                              <div class="label">Pendiente</div>
                              <h5 style="color: orange">
                                {{ detalle.cantidad_abierta }}
                              </h5>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="el-tablo highlight">
                              <div class="label">Solcitado</div>
                              <h5 style="color: DodgerBlue">
                                {{ detalle.cantidad }}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-10 offset-sm-1">
                        <div class="os-progress-bar primary">
                          <div class="bar-labels">
                            <div class="bar-label-left">
                              <span>% Pickeado:</span>
                            </div>
                            <div class="bar-label-right col-8">
                              <div class="progress">
                                <div
                                  v-if="detalle"
                                  class="
                                    progress-bar progress-bar-striped
                                    bg-success
                                    progress-bar-animated
                                  "
                                  role="progressbar"
                                  :style="{
                                    width:
                                      (
                                        100 -
                                        (detalle.cantidad_abierta * 100) /
                                          detalle.cantidad
                                      ).toFixed(2) + '%',
                                  }"
                                >
                                  <a style="color: black"
                                    >{{
                                      (
                                        100 -
                                        (detalle.cantidad_abierta * 100) /
                                          detalle.cantidad
                                      ).toFixed(2)
                                    }}%</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--END - Projects list-->
            <div class="table-responsive" v-if="cambiar_UiTabla">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="det in current.req_traslado_e.reqtrasladod_set"
                    v-bind:key="det.id"
                    @click="abrirModalEliminarDetalle(det)"
                  >
                    <td>
                      <div class="value">
                        <small class="font-weight-bold">{{
                          det.producto.sku
                        }}</small>
                      </div>
                      <small
                        ><div class="value">
                          {{ det.producto.nombre }}
                        </div></small
                      >
                      Pickeada:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cantidad - det.cantidad_abierta }}
                        <i
                          v-if="det.cantidad_abierta == 0"
                          class="fas fa-check"
                        ></i>
                      </span>
                    </td>
                    <td>
                      <div
                        class="badge badge-info"
                        v-if="det.producto.categoria"
                      >
                        {{ det.producto.categoria.nombre }}
                      </div>
                      <br />
                      Solicitada:
                      <span
                        class="sub-value font-weight-bold"
                        style="color: blue"
                      >
                        {{ det.cantidad }}
                      </span>

                      <br />
                      Pendiente:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cantidad_abierta }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade"
      id="eliminarDetalle"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog madal-animated modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h6>
                  {{ detalle.producto.sku }}
                </h6>
                <h6>
                  {{ detalle.producto.nombre }}
                </h6>
              </div>
              <div class="row">
                <br />
                <button
                  class="btn btn-block btn-md btn-danger"
                  type="button"
                  @click="eliminarDetalle(detalle)"
                >
                  Eliminar Linea
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
export default {
  components: {},
  data() {
    return {
      cambiar_UiTabla: false,
      detalle: {
        producto: "",
      },
    };
  },
  props: ["current"],
  computed: {},
  mounted() {},
  methods: {
    abrirModalEliminarDetalle(detalle) {
      let self = this;
      $("#eliminarDetalle").modal("show");
      self.detalle = detalle;
    },
    eliminarDetalle() {
      let self = this;
      DynamicService.postAction(
        "inv",
        "transferencia_stock",
        this.current.id,
        "eliminar_detalle",
        {
          id_linea: self.detalle.id,
        }
      )
        .then((response) => {
          self.$emit("refreshCurrent");
          $("#eliminarDetalle").modal("hide");
        })
        .catch((error) => {
          Notifications.alert.error(
            "Eliminar detalle",
            error.response.data.detail
          );
        });
    },
    cambiarUiTabla() {
      let self = this;
      self.cambiar_UiTabla = !self.cambiar_UiTabla;
    },
  },
};
</script>
